var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIceLogo = function SvgIceLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2E30F0",
    d: "M8 .577a2 2 0 0 1 2 0l5.794 3.346a2 2 0 0 1 1 1.732v6.69a2 2 0 0 1-1 1.732L10 17.423a2 2 0 0 1-2 0l-5.794-3.346a2 2 0 0 1-1-1.732v-6.69a2 2 0 0 1 1-1.732z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m8.492 13.244.007-8.49h1.012l-.007 8.49z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m12.398 11.566-7.3-4.252.507-.881 7.3 4.25z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m5.6 11.56 7.307-4.239-.505-.882-7.306 4.238z",
    clipRule: "evenodd"
  })));
};
export default SvgIceLogo;